import styled from 'styled-components';
import { Table } from 'react-bootstrap';

export const Container = styled.div`
  background: linear-gradient(135deg, rgba(26, 26, 46, 0.02) 0%, rgba(244, 241, 222, 0.05) 100%);
  border-radius: 12px;
  padding: 20px;
  margin: 10px 0;
`;

export const TableBox = styled.div`
  border: 1px solid rgba(26, 26, 46, 0.1);
  border-radius: 12px;
  overflow-x: auto;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 20px rgba(26, 26, 46, 0.08);
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 8px 30px rgba(26, 26, 46, 0.12);
  }
`;

export const CustomTableHead = styled.thead`
  background: linear-gradient(135deg, rgba(26, 26, 46, 0.05) 0%, rgba(26, 26, 46, 0.02) 100%);
  border-bottom: 2px solid rgba(26, 26, 46, 0.1);
`;

export const CustomTableBody = styled.tbody`
  background: rgba(255, 255, 255, 0.95);
`;

export const CustomTableRow = styled.tr`
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(26, 26, 46, 0.05);

  &:hover {
    background: rgba(26, 26, 46, 0.02);
    transform: translateY(-1px);
  }

  &:nth-child(even) {
    background: rgba(244, 241, 222, 0.03);
  }
`;

export const CustomTH = styled.th`
  padding: 16px 12px !important;
  text-align: left !important;
  border-bottom: 2px solid rgba(26, 26, 46, 0.1) !important;
  color: #1a1a2e !important;
  font-family: 'Nunito', sans-serif !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  background: linear-gradient(135deg, rgba(26, 26, 46, 0.05) 0%, rgba(26, 26, 46, 0.02) 100%) !important;
  transition: all 0.2s ease !important;

  &:hover {
    background: linear-gradient(135deg, rgba(26, 26, 46, 0.08) 0%, rgba(26, 26, 46, 0.04) 100%) !important;
    color: #1a1a2e !important;
  }
`;

export const CustomTD = styled.td`
  padding: 16px 12px;
  border-bottom: 1px solid rgba(26, 26, 46, 0.05);
  color: #1a1a2e;
  font-size: 14px;
  vertical-align: middle;
`;

// TH específico para a coluna de ações, com alinhamento central forçado
export const ActionsTH = styled(CustomTH)`
  text-align: center !important;
`;

export const CustomTable = styled(Table)`
  margin: 0;
  min-width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 12px;
  overflow: hidden;
`;

export const CustomDetailTH = styled(CustomTH)`
  width: auto !important;
  white-space: nowrap !important;
  text-align: right !important;
  background: linear-gradient(135deg, rgba(26, 26, 46, 0.05) 0%, rgba(26, 26, 46, 0.02) 100%) !important;
  
  &:hover {
    background: linear-gradient(135deg, rgba(26, 26, 46, 0.08) 0%, rgba(26, 26, 46, 0.04) 100%) !important;
    color: #1a1a2e !important;
  }
`;

export const ServiceDeskHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  gap: 1rem;
  flex-wrap: wrap;
  padding: 0;
`;

export const FilterSection = styled.div`
  display: flex;
  flex: 1;
  gap: 1rem;
  align-items: center;
  min-width: 300px;
`;

export const FilterContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  width: 100%;
`;

export const FilterInputContainer = styled.div`
  flex: 2;
`;

export const FilterSelectContainer = styled.div`
  flex: 1;
`;

export const FilterDateContainer = styled.div`
  flex: 1;
`;

export const CustomInputGroup = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export const SearchIconBox = styled.div`
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 5;
  color: #a7a7a7;
  font-size: 20px;
`;

export const CustomFormControl = styled.input`
  padding-left: 32px;
  border-radius: 50px !important;
  border: 1px solid #ced4da;
  padding: 8px 12px 8px 32px;
  background: #ffffff;
  color: #495057;
  transition: all 0.2s ease;
  font-size: 14px;
  width: 100%;
  cursor: text !important;
  caret-color: #0d6efd !important;

  &:focus {
    border-color: #80bdff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    outline: none;
    cursor: text !important;
    caret-color: #0d6efd !important;
  }

  &::placeholder {
    color: #a7a7a7;
    font-style: italic;
  }
`;

export const CustomSelect = styled.select`
  padding-left: 15px;
  border-radius: 50px !important;
  color: #a7a7a7;
  font-style: italic;
  border: 1px solid #ced4da;
  padding: 8px 12px 8px 15px;
  background: #ffffff;
  transition: all 0.2s ease;
  font-size: 14px;
  width: 100%;
  cursor: pointer !important;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23666' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 16px;

  &:focus {
    border-color: #80bdff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    outline: none;
    cursor: pointer !important;
  }
`;

export const CustomDateInput = styled.input`
  border-radius: 50px !important;
  border: 1px solid #ced4da;
  padding: 8px 12px;
  background: #ffffff;
  color: #495057;
  transition: all 0.2s ease;
  font-size: 14px;
  width: 100%;
  cursor: text !important;
  caret-color: #0d6efd !important;

  &:focus {
    border-color: #80bdff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    outline: none;
    cursor: text !important;
    caret-color: #0d6efd !important;
  }
`;


export const CustomButton = styled.button`
  border: 1px solid #6c757d;
  color: #6c757d;
  background: #ffffff;
  font-weight: 500;
  border-radius: 6px;
  padding: 8px 12px;
  transition: all 0.2s ease;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 14px;

  &:hover {
    background: #6c757d;
    color: #ffffff;
    border-color: #6c757d;
  }

  &:active {
    transform: translateY(0);
  }
`;

export const ResultsCounter = styled.div`
  color: #6c757d;
  font-size: 14px;
  font-weight: 500;
  margin-top: 15px;
  padding: 8px 0;
  text-align: center;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;
`;

export const StatusBadge = styled.span`
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  
  &.status-aberto {
    background: rgba(255, 193, 7, 0.2);
    color: #856404;
    border: 1px solid rgba(255, 193, 7, 0.3);
  }
  
  &.status-em-andamento {
    background: rgba(13, 202, 240, 0.2);
    color: #055160;
    border: 1px solid rgba(13, 202, 240, 0.3);
  }
  
  &.status-concluido {
    background: rgba(25, 135, 84, 0.2);
    color: #0a3622;
    border: 1px solid rgba(25, 135, 84, 0.3);
  }
  
  &.status-cancelado {
    background: rgba(108, 117, 125, 0.2);
    color: #495057;
    border: 1px solid rgba(108, 117, 125, 0.3);
  }
  
  &.prioridade-alta {
    background: rgba(220, 53, 69, 0.2);
    color: #721c24;
    border: 1px solid rgba(220, 53, 69, 0.3);
  }
  
  &.prioridade-media {
    background: rgba(255, 193, 7, 0.2);
    color: #856404;
    border: 1px solid rgba(255, 193, 7, 0.3);
  }
  
  &.prioridade-baixa {
    background: rgba(108, 117, 125, 0.2);
    color: #495057;
    border: 1px solid rgba(108, 117, 125, 0.3);
  }
`;

// Botão de ação para a lista (mesma aparência do Incidents)
export const ListActionButton = styled.button`
  background: rgba(26, 26, 46, 0.1);
  border: 1px solid rgba(26, 26, 46, 0.2);
  color: #1a1a2e;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  text-decoration: none;

  &:hover {
    background: #1a1a2e;
    color: #ffffff;
    transform: translateY(-1px);
  }

  &.primary:hover { background: #1a1a2e; }
  &.secondary:hover { background: #6b7280; }
  &.danger:hover { background: #dc2626; }
  &.info:hover { background: #0891b2; }
`;
